import { Grid, Typography } from '@mui/material'
import React from 'react'
import { CardHighlightProducer } from 'src/Pages/components/CardHighlightProducer/CardHighlightProducer'
import { useMetricsContext } from 'src/Contexts/Metrics/ContextMetrics'

export const TopsProducers = () => {
  const { valuesCardsTopsProducersHome } = useMetricsContext();

  return (
    <>
      <Grid item md={12} xs={12}>
        <Typography fontWeight="bold" color="text.secondary" sx={{ mb: "12px" }}>
          Melhores Produtores
        </Typography>
      </Grid>

      <Grid container item spacing={2} md={12} xs={12} >
        <Grid item md={12} xs={12}>
          <CardHighlightProducer
            title="Top 1 - (Corretor)"
            name={valuesCardsTopsProducersHome?.corretor ? `${valuesCardsTopsProducersHome?.corretor?.id} - ${valuesCardsTopsProducersHome?.corretor?.nome} ` : "Não encontrado"}
            document=""
            countSales={valuesCardsTopsProducersHome?.corretor?.total_contratos || "0"}
            valueProduction={valuesCardsTopsProducersHome?.corretor?.total_vendas || "0"}
          />
        </Grid>
        <Grid item md={12} xs={12}>
          <CardHighlightProducer
            title="Top 1 - (Supervisor)"
            name={valuesCardsTopsProducersHome?.supervisor ? `${valuesCardsTopsProducersHome?.supervisor?.id} - ${valuesCardsTopsProducersHome?.supervisor?.nome} ` : "Não encontrado"}
            document=""
            countSales={valuesCardsTopsProducersHome?.supervisor?.total_contratos || "0"}
            valueProduction={valuesCardsTopsProducersHome?.supervisor?.total_vendas || "0"}
          />
        </Grid>
        <Grid item md={12} xs={12}>
          <CardHighlightProducer
            title="Top 1 - (Gerente)"
            name={valuesCardsTopsProducersHome?.gerente ? `${valuesCardsTopsProducersHome?.gerente?.id} - ${valuesCardsTopsProducersHome?.gerente?.nome} ` : "Não encontrado"}
            document=""
            countSales={valuesCardsTopsProducersHome?.gerente?.total_contratos || "0"}
            valueProduction={valuesCardsTopsProducersHome?.gerente?.total_vendas || "0"}
          />
        </Grid>
      </Grid>
    </>
  )
}